import { memo } from 'react';

import type { SetsTableProps } from '@/features/workout-creator/ui/v2/sets-editor/types/sets-editor.types';

/**
 * SetsTable component that provides the table wrapper structure
 * Simple container component with consistent styling
 */
function SetsTableComponent({ gridTemplateColumns, children }: SetsTableProps) {
	return <div className="overflow-hidden bg-white">{children}</div>;
}

// Memoize for consistency, though this component rarely changes
export const SetsTable = memo(SetsTableComponent);
